import React from 'react';
import { observer, inject } from 'mobx-react';
import { Spin } from 'antd';
import styles from './Loading.less';

@inject('globalStore')
@observer
class Loading extends React.Component {
  render() {
    const { loadingStatus, loadingTip } = this.props.globalStore;
    return (
      <div className={loadingStatus ? styles.loadingContainer : ''}>
        <Spin spinning={loadingStatus} tip={loadingTip} />
      </div>
    );
  }
}
export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js